
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'black';
}

const Button: React.FC<ButtonProps> = ({ children, className = '', variant = 'primary', ...props }) => {
  let colorClass = 'bg-white hover:bg-gray-100 text-black';
  
  if (variant === 'secondary') {
    colorClass = 'bg-highlight hover:bg-yellow-400 text-black';
  }
  if (variant === 'danger') {
    colorClass = 'bg-alert hover:bg-red-600 text-white';
  }
  if (variant === 'black') {
    colorClass = 'bg-black hover:bg-gray-800 text-white';
  }

  return (
    <button
      className={`
        border-4 border-black
        shadow-hard active:shadow-none active:translate-x-[4px] active:translate-y-[4px]
        font-bold text-lg
        px-6 py-2
        transition-all duration-100
        lowercase
        ${colorClass}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
